<template>
  <div class="card border h-100">
    <slot></slot>
  </div>
</template>
